var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 22,
    viewBox: "0 0 17 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.57881,
    cy: 6.27803,
    r: 4.77803,
    stroke: "#9BAEBC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.00002 17.7016C0.998732 17.3657 1.07385 17.0339 1.2197 16.7313C1.67736 15.816 2.96798 15.3308 4.03892 15.1112C4.81128 14.9463 5.59431 14.8362 6.38217 14.7816C7.84084 14.6535 9.30793 14.6535 10.7666 14.7816C11.5544 14.8369 12.3374 14.947 13.1099 15.1112C14.1808 15.3308 15.4714 15.7702 15.9291 16.7313C16.2224 17.3481 16.2224 18.0642 15.9291 18.681C15.4714 19.6421 14.1808 20.0814 13.1099 20.2919C12.3384 20.4636 11.5551 20.5768 10.7666 20.6306C9.57937 20.7313 8.38659 20.7496 7.19681 20.6855C6.92221 20.6855 6.65677 20.6855 6.38217 20.6306C5.59663 20.5775 4.81632 20.4642 4.04807 20.2919C2.96798 20.0814 1.68652 19.6421 1.2197 18.681C1.0746 18.3749 0.999552 18.0403 1.00002 17.7016Z",
    stroke: "#9BAEBC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfile);
export default __webpack_public_path__ + "static/media/IconProfile.b8400049.svg";
export { ForwardRef as ReactComponent };